import { ComparisonOperator } from 'api/schemas/comparisonOperator';

const comparisonOperatorLabelsShort: Record<ComparisonOperator, string> = {
  [ComparisonOperator.at_or_below]: '≤',
  [ComparisonOperator.at_or_above]: '≥',
};

const comparisonOperatorLabelsLong: Record<ComparisonOperator, string> = {
  [ComparisonOperator.at_or_below]: 'below',
  [ComparisonOperator.at_or_above]: 'above',
};

export const inverseComparisonOperator = (operator: ComparisonOperator): ComparisonOperator => {
  if (operator === ComparisonOperator.at_or_below) {
    return ComparisonOperator.at_or_above;
  }
  if (operator === ComparisonOperator.at_or_above) {
    return ComparisonOperator.at_or_below;
  }
  return operator;
};

export const formatInstructionComparisonOperator = (
  operator: ComparisonOperator,
  format: 'short' | 'long' = 'short'
): string => {
  const labels = format === 'short' ? comparisonOperatorLabelsShort : comparisonOperatorLabelsLong;
  return labels[operator] || operator;
};
